
class CustomTab extends HTMLElement {
    connectedCallback() {
        this.btns = this.querySelectorAll('.btn-tab');
        this.contents = this.querySelectorAll('.tab-content');
        this.btns.forEach( btn => {
            btn.addEventListener('click', (e) => {
                this.toggle(e);
            });
        })
    }

    toggle(e) {
        const { target } = e;
        if( target.classList.contains('active')) return
        
        this.clearAllActive(this.btns);
        this.clearAllActive(this.contents);

        const activeName = target.dataset.name;

        console.log(activeName);

        target.classList.add('active');
        this.querySelector(`[data-content="${activeName}"]`).classList.add('active');
    }

    clearAllActive(arr) {
        arr.forEach( el => {
            el.classList.remove('active');
        })
    }
}

customElements.define('custom-tab', CustomTab);